import React from 'react'

interface IconProps {
  className?: string
}

const Mention = ({ className }: IconProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 2.5C8.67858 2.5 6.38231 3.90385 4.94644 5.84227C3.54189 7.73842 3 10.0859 3 12C3 13.8654 3.39543 16.2326 4.82144 18.1577C6.28685 20.136 8.73106 21.5 12.5 21.5H12.5454C13.2563 21.5 13.8118 21.5001 14.374 21.4298C14.9653 21.3559 15.5347 21.2092 16.3162 20.9487C16.8402 20.774 17.1233 20.2077 16.9487 19.6838C16.774 19.1598 16.2077 18.8767 15.6838 19.0513C14.9653 19.2908 14.5347 19.3941 14.126 19.4452C13.7001 19.4985 13.2672 19.5 12.5 19.5C9.26894 19.5 7.46315 18.364 6.42856 16.9673C5.35457 15.5174 5 13.6346 5 12C5 10.4141 5.45811 8.51158 6.55356 7.03273C7.61769 5.59615 9.32142 4.5 12 4.5C14.9939 4.5 16.6844 5.5216 17.6535 6.7457C18.6565 8.01273 19 9.64109 19 11C19 12.9489 18.7511 14.1367 18.4181 14.8028C18.2586 15.1217 18.0977 15.2851 17.9687 15.3711C17.846 15.4529 17.7 15.5 17.5 15.5C16.9905 15.5 16.7949 15.3418 16.7057 15.2348C16.5898 15.0957 16.5 14.8514 16.5 14.5V7.5C16.5 6.94772 16.0523 6.5 15.5 6.5C14.9477 6.5 14.5 6.94772 14.5 7.5V8.26871C13.7209 7.48866 12.684 7 11.5 7C8.89347 7 7 9.36818 7 12C7 14.6318 8.89347 17 11.5 17C12.7656 17 13.8631 16.4417 14.6573 15.566C14.7618 15.8971 14.9256 16.2228 15.1693 16.5152C15.7051 17.1582 16.5095 17.5 17.5 17.5C18.05 17.5 18.5915 17.3596 19.0781 17.0352C19.5586 16.7149 19.9289 16.2533 20.2069 15.6972C20.7489 14.6133 21 13.0511 21 11C21 9.35891 20.5935 7.23727 19.2215 5.5043C17.8156 3.7284 15.5061 2.5 12 2.5ZM9 12C9 10.2135 10.2405 9 11.5 9C12.7595 9 14 10.2135 14 12C14 13.7865 12.7595 15 11.5 15C10.2405 15 9 13.7865 9 12Z"
      fill="currentColor"
    />
  </svg>
)

export default Mention
